<div *ngIf="jobcard.collectionsDeliveries?.allowCollection" class="collections-deliveries-container">

    <div class="collections-deliveries-header">
        <div class="collections-deliveries-title">{{ 'bikeshop.workshop.jobcard.collections_deliveries_information' | translate }}
        </div>
        <hub-button [icon]="'arrow-up-right'" [style]="'borderless'" [size]="'lg'"
            (buttonClick)="showCollectionDeliveryDetails()"></hub-button>
    </div>

    <div class="label margin-top-16">
        {{ 'bikeshop.collections.address' | translate }}:
    </div>
    <div class="value">
        {{ jobcard.collectionsDeliveries.collectionInfo.fullAddress.address || 'N/A' }}
    </div>
    <div class="label margin-top-8">
        {{ 'bikeshop.workshop.jobcard.collections_deliveries_date' | translate }}:
    </div>
    <div class="value">
        {{ jobcard.collectionsDeliveries.collectionInfo.scheduleDate | date: countryData.AngularDateFormat }} / {{
        jobcard.collectionsDeliveries.collectionInfo.timeSlot.name }}
    </div>
</div>